import { memo } from "react";
import styled from "styled-components";

export const LockButton = memo(() => {
  return (
    <Sdiv title="ロックされています" style={{ fontSize: "24px" }}>
      <i className="fas fa-lock" />
    </Sdiv>
  );
});

const Sdiv = styled.div`
  color: ${(props) => props.theme.color.lockReport} !important;
`;
